$(window).on("load", function() {
          ;
      
     
      
      var id = $("body").attr("id");


if(id.includes("450grm")) {

  
   $(".wiyk").remove();
  otherKits();
    
 // $("#ui-id-3").html("What's in your kit"); 
  //$("#ui-id-3").click(); 
  var select_id = $("#productSelect--332179375-option-1").val();
  
  
  if(select_id.includes("Yes")) {
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
    
  
       $(".extra_kit_info").remove();
    $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p>This Roof Kit<span>INCLUDES TOOLS<\/span><\/p>\r\n<\/div>");
 
             $(".wiyk1").remove();
    
       $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view a list of kit items & tools!<\/strong><\/p>\r\n<\/div>");
  
  } else {
    
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
  
       $(".extra_kit_info").remove();
      $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p><span>THIS KIT DOES NOT INCLUDE TOOLS<\/span><\/p><p>If you need a full tool kit, choose <span>Yes please!<\/span> in the drop down \"Do you require a toolkit?\" instead of No thanks, I'm okay.<\/p>\r\n<\/div>");
  
     $(".wiyk1").remove();
    $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view kit items<\/strong><\/p>\r\n<\/div>");

  
  }
    
    
    



} else if(id.includes("600grm")) {
  
  $(".wiyk").remove();
  otherKits();
  
 
  // $("#ui-id-3").html("What's in your kit");   
	//$("#ui-id-3").click(); 
  
  
 var select_id = $("#productSelect--332178655-option-1").val();
  

  
  
    if(select_id.includes("Yes")) {
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
      
      
    $(".extra_kit_info").remove();
    $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p>This Roof Kit <span>INCLUDES TOOLS<\/span><\/p>\r\n<\/div>");
 
             $(".wiyk1").remove();
       $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view a list of kit items & tools!<\/strong><\/p>\r\n<\/div>");
  
      
      
      
    
  } else {
    
   
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
 
     $(".extra_kit_info").remove();
      $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p><span>THIS KIT DOES NOT INCLUDE TOOLS<\/span><\/p><p>If you need a full tool kit, choose <span>Yes please!<\/span> in the drop down \"Do you require a toolkit?\" instead of No thanks, I'm okay.<\/p>\r\n<\/div>");
  
    
         $(".wiyk1").remove();
        $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view kit items<\/strong><\/p>\r\n<\/div>");
  }
    

} else {
  
  // $("#ui-id-3").hide();  
  
  
}

    
     $("#productSelect--332178655-option-1").change(function(){
     var select_id = $(this).val();
      
         if(select_id.includes("Yes")) {
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
    
       
    $(".extra_kit_info").remove();
    $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p>This Roof Kit <span>INCLUDES TOOLS<\/span><\/p>\r\n<\/div>");
 
             $(".wiyk1").remove();
       $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view a list of kit items & tools!<\/strong><\/p>\r\n<\/div>");
  
         
         } else {
    
    
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
  
    
    $(".extra_kit_info").remove();
    $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p><span>THIS KIT DOES NOT INCLUDE TOOLS<\/span><\/p><p>If you need a full tool kit, choose <span>Yes please!<\/span> in the drop down \"Do you require a toolkit?\" instead of No thanks, I'm okay.<\/p>\r\n<\/div>");
  
         $(".wiyk1").remove();
       $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view kit items<\/strong><\/p>\r\n<\/div>");
  }
    
  });
    
    
   
     $("#productSelect--332179375-option-1").change(function(){
     var select_id = $(this).val();
       
     
         if(select_id.includes("Yes")) {
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_tools_large.png");
    
       
    $(".extra_kit_info").remove();
    $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p>This Roof Kit <span>INCLUDES TOOLS<\/span><\/p>\r\n<\/div>");
 
             $(".wiyk1").remove();
       $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view a list of kit items & tools!<\/strong><\/p>\r\n<\/div>");
  
         
         
         } else {
    
   
    $(".product-single__photos img").attr("src","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools.png");
$(".product-single__photos .fancybox").attr("href","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
$(".product-single__photos img").attr("data-large","https://cdn.shopify.com/s/files/1/0600/8557/files/kit_with_no_tools_large.png");
 
  $(".extra_kit_info").remove();
    $(".product--images").append("<div class=\"extra_kit_info\">\r\n    <p><span>THIS KIT DOES NOT INCLUDE TOOLS<\/span><\/p><p>If you need a full tool kit, choose <span>Yes please!<\/span> in the drop down \"Do you require a toolkit?\" instead of No thanks, I'm okay.<\/p>\r\n<\/div>");
 
             $(".wiyk1").remove();
       $(".product--images").append("<div class=\"select-wrapper wiyk1\">\r\n<p><i class=\"fa fa-briefcase\"><\/i>&nbsp;<strong><span>CLICK HERE</span> to view kit items<\/strong><\/p>\r\n<\/div>");
  
  }
    
  });
      
 
      
      
      
   }); // WINDOW LOAD END

    function otherKits() {
    
          //COLOURED KITS WHAT IS IN YOUR KIT
      
 //$("#600grm-fibreglass-roof-kits-for-foot-traffic-choice-of-topcoats-apex .grid.product--option.addtocart--button").before("<div class=\"select-wrapper wiyk\">\r\n<p><strong>What\'s in your kit? <i class=\"fa fa-briefcase\"><\/i><\/strong><\/p>\r\n<\/div>");
 //$("#450grm-roofing-kits-in-a-range-of-topcoat-colours-apex .grid.product--option.addtocart--button").before("<div class=\"select-wrapper wiyk\">\r\n<p><strong>What\'s in your kit? <i class=\"fa fa-briefcase\"><\/i><\/strong><\/p>\r\n<\/div>");
 //$("#cure-it-grp-roofing-kits-fire-retardent-amp-450grm-apex .grid.product--option.addtocart--button").before("<div class=\"select-wrapper wiyk\">\r\n<p><strong>What\'s in your kit? <i class=\"fa fa-briefcase\"><\/i><\/strong><\/p>\r\n<\/div>");
    
 }



